<template>
  <div>
     
        <v-row no-gutters style="height:80vh">
          <v-col style="background-color:#243832;height:100vh" cols="5">
            <v-row class="ma-5">
              <v-btn dark to="/" text style="text-transform:none"> <v-icon>mdi-keyboard-backspace</v-icon> Return to menu</v-btn>
            </v-row>
          </v-col>
          <v-col cols="7" style="position:relative;height:100vh;width:100%">
            <v-row  no-gutters align="center" style="width:100%" justify="center">
               <v-col cols="6" style="width:100%" >
                 <div style="overflow-y: scroll;height:80vh;width:100%">
                     <v-card  class="pa-3" style="width:100%;height:20vh" v-for="item in $store.state.cart" :key="item">
                    <v-row no-gutters>
                        <v-avatar

                        size="76"
                      >
                        <img :src="item.itemData.description"  />
                      </v-avatar>
                      <v-spacer></v-spacer>
                      <div>
                        <p class="font-weight-bold text-h6">{{item.itemData.name}}</p>
                    
                      </div>
                      <v-spacer></v-spacer>
                      <p class="text-caption font-weight-bold">${{item.itemData.variations[0].itemVariationData.priceMoney.amount*0.01}}</p>
                    <v-spacer></v-spacer>
                    </v-row>
                </v-card>
                <br>
                <v-card style="height:20vh"  class="pa-3">  
                  <v-row no-gutters>
                      <div>
                        <p class="font-weight-bold">total price </p>
                      </div>
                      <v-spacer></v-spacer>
                      <div>
                        <p>${{totalprice.toFixed(2)}}</p>
                      </div>
                  </v-row>
            </v-card>
                 </div>
                 
               </v-col>
            </v-row>
            <p class="text-right mr-3" ><v-btn v-bind="attrs"
          v-on="on"  @click="checkout" rounded large dark color="green darken-1">Checkout ${{totalprice}}</v-btn></p>
             
               <v-slide-y-reverse-transition>
  
        <div class="pa-5" style="position:absolute;z-index:1;bottom:0;width:100%;background-color:#efefef;" v-if="dialog">
                <v-row align="center" justify="center" no-gutters>
            <v-btn @click="dialog=!dialog" icon><v-icon>mdi-close</v-icon></v-btn>
            <v-spacer></v-spacer>
          </v-row>
                <div >
                    <Test    />
                </div>
        </div>
        
        <p v-else></p>
  
</v-slide-y-reverse-transition> 

            
               
           
     
          </v-col>
        </v-row>

  </div>
</template>

<script>
import Test from '../components/Test.vue'
export default {
  name: 'Card',
  components:{
      Test
  },

  data: () => ({
    dialog:false,
    totalprice:0,
    
  }),
  methods:{
    checkout(){
    //   this.dialog=!this.dialog
      this.$store.commit("addTotalPrice",this.totalprice)
      this.dialog=true
    }
  },
  mounted(){
    setInterval(() => {
      this.totalprice=0
      for(var i=0;i<this.$store.state.cart.length;i++){
        this.totalprice+=this.$store.state.cart[i].itemData.variations[0].itemVariationData.priceMoney.amount*0.01
        
      }
    }, 1000);
  }
};
</script>


<style>
 ::-webkit-scrollbar {
    display: none;
    }
   

</style>